module.exports = __webpack_public_path__ + "3cf982601d4341a49b75861122298dd5.jpg";